"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class Zoomer {
  constructor(initialZoomLevel) {
    __publicField(this, "zoomLevel");
    this.zoomLevel = initialZoomLevel || 1;
  }
  zoomIn() {
    if (this.canZoomIn()) {
      this.zoomLevel += 0.3;
    }
  }
  zoomOut() {
    if (this.canZoomOut()) {
      this.zoomLevel -= 0.3;
    }
  }
  canZoomOut() {
    return this.zoomLevel > 1;
  }
  canZoomIn() {
    return this.zoomLevel < 3;
  }
}
export default Zoomer;
